import React from 'react';
import { CalendarCheck, SprayCan, Home, ArrowRight } from 'lucide-react';
import { useT } from '../i18n/LanguageContext';

const icons = [CalendarCheck, SprayCan, Home];

export default function Steps() {
  const { t } = useT();

  const steps = [1, 2, 3].map((i) => ({
    Icon: icons[i - 1],
    id: i,
    title: t(`steps.${i}.title`),
    sub: t(`steps.${i}.sub`),
  }));

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-16">
          <p className="uc-kicker mb-3">{t('steps.kicker')}</p>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-[#1a2851]">
            {t('steps.heading1')} <span className="text-[#4dbfae]">{t('steps.heading2')}</span>
          </h2>
        </div>

        <div className="flex flex-col lg:flex-row items-center justify-center gap-6 lg:gap-2">
          {steps.map((step, idx) => {
            const Icon = step.Icon;
            return (
              <React.Fragment key={step.id}>
                <div className="text-center max-w-xs uc-lift px-4">
                  <div className="relative inline-block mb-6">
                    <div className="w-24 h-24 rounded-full bg-[#f2fbf9] flex items-center justify-center text-[#4dbfae] mx-auto">
                      <Icon size={36} />
                    </div>
                    <span className="absolute -top-1 -right-1 w-9 h-9 rounded-full bg-[#4dbfae] text-white flex items-center justify-center text-sm font-bold border-4 border-white">
                      {step.id}
                    </span>
                  </div>
                  <h3 className="font-serif text-2xl font-bold text-[#1a2851] mb-2">{step.title}</h3>
                  <p className="text-[#5b6469]">{step.sub}</p>
                </div>
                {idx < steps.length - 1 && (
                  <div className="hidden lg:flex items-center text-[#4dbfae]">
                    <ArrowRight size={40} strokeWidth={1.2} />
                  </div>
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </section>
  );
}
